var otherSourcesRequest = axios.create({
  baseURL: '/api/othersources'
});

/** Thingnario 來源帳號與各自的 API 配額 */
export var getThingnarioAccountsApi = function getThingnarioAccountsApi() {
  return otherSourcesRequest.post('/thingnario/accounts').then(function (res) {
    return res.data;
  });
};

/**
 * Thingnario 全電廠總覽：今日發電、PR、日照曲線、進行中告警
 * @param {string} [accountId] 只看單一來源帳號時給
 */
export var getThingnarioOverviewApi = function getThingnarioOverviewApi(accountId) {
  return otherSourcesRequest.post('/thingnario/overview', {
    accountId: accountId
  }).then(function (res) {
    return res.data;
  });
};

/**
 * 單一電廠的逆變器昨日 PR 比較（展開卡片才呼叫，會多吃一次 API 配額）
 * @param {string} accountId
 * @param {string} plantNo
 */
export var getThingnarioPlantInvertersApi = function getThingnarioPlantInvertersApi(accountId, plantNo) {
  return otherSourcesRequest.post('/thingnario/plantInverters', {
    accountId: accountId,
    plantNo: plantNo
  }).then(function (res) {
    return res.data;
  });
};

/**
 * 歷史告警（已結束的事件）
 * @param {object} params { accountId, start: '2026-08-15', end: '2026-08-21' }
 */
export var getThingnarioEventsApi = function getThingnarioEventsApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return otherSourcesRequest.post('/thingnario/events', params).then(function (res) {
    return res.data;
  });
};